import React from 'react';

import { connect } from 'react-redux';

import NotAuthorized from './NotAuthorized';
import Loading from './Loading';
import Conteudo from './Conteudo';

let mapStateToProps = ({ auth }) => ({ auth });

// Child as a function
export default connect(mapStateToProps)(({ children, ...otherProps }) => {
  let rolesFn = roles =>
    otherProps.auth.roles.some(r1 => roles.some(r2 => r1 === r2));
  let unidadesFn = roles => unidade => [
    ...new Set(
      otherProps.auth.apartamentos
        .filter(
          u =>
            roles.some(r => r === u.role) &&
            (u.unidade === unidade ||
              (unidade === null && u.unidade) ||
              unidade === true ||
              (unidade === false && !u.unidade))
        )
        .map(u => u.unidade)
    )
  ];

  let output = children(otherProps, rolesFn, unidadesFn);

  if (output && (!(output instanceof Array) || output.length)) {
    return output;
  }

  let fetching = otherProps.auth.fetching;
  if (1 === fetching) {
    return <Loading />;
  } else if (2 === fetching) {
    return <NotAuthorized />;
  }
  return <Conteudo>Você precisa estar logado.</Conteudo>;
});



// WEBPACK FOOTER //
// ./src/AuthProvider.js